/**
 * Base class for passwordless authentication service.
 * Subclasses implement platform-specific API calls.
 */
export class PasswordlessAuthServiceBase {
}
